export default __webpack_public_path__ + "static/media/toast-success.a9331c30.svg";